import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Container } from "../../styles/GlobalStyles";
import {
  Form,
  Button,
  Content,
  CardHeader,
  CardTitle,
  BackButtonContainer,
  BackButton,
  RegisterButton,
} from "./styled";

import api from "../../api/axios";

import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../store/modules/auth/actions";
import WhatsappButton from "../../components/WhatsappButton";
import { toast } from "react-toastify";

export default function PasswordForget() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const [sent, setSent] = useState(false);

  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsLoading(true);

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setError("Insira um email válido");
        setIsLoading(false);
        return;
      }

      await api.post("/user/password-forget", { email: email });

      setSent(true);
      setIsLoading(false);
    } catch (err) {
      toast.error(`Erro: ${err.response.data.error}`);
      setIsLoading(false);
    }
  };

  const handleBackButton = () => {
    if (location.state?.backOportunities) {
      window.location.href = "https://ticoopbrasil.coop.br/oportunidades-ti/";
    } else {
      navigate(-1);
    }
  };

  const handleLoginBackButton = () => {
    navigate(-1);
  };

  // Prevents code breaking by manually changing the redux state
  useEffect(() => {
    async function checkTokenAndRedirect() {
      try {
        await api.get("/user/me");
        navigate("/perfil");
      } catch (err) {
        dispatch(actions.loginFailure());
      }
    }

    if (isLoggedIn) {
      checkTokenAndRedirect();
    }
  }, [isLoggedIn, navigate, dispatch]);

  return (
    <Content>
      <WhatsappButton />
      <Container>
        <CardHeader>
          <img
            src="https://ticoopbrasil.coop.br/wp-content/uploads/2020/12/logo-ticoop-cor.png.webp"
            alt="Logo Ticoop"
          />
          <CardTitle>
            {!sent
              ? "Esqueci minha senha"
              : "Foi enviado um link para a alteração da senha para o seu email"}
          </CardTitle>
        </CardHeader>
        {!sent ? (
          <Form onSubmit={handleSubmit}>
            {/* Username */}
            <label for="email">E-mail:</label>
            <input
              id="email"
              name="email"
              type="text"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError("");
              }}
            />
            <div className="erro">{error ? error : ""}</div>
            <Button disabled={isLoading} type="submit">
              Enviar
            </Button>
            <RegisterButton onClick={handleLoginBackButton}>
              Voltar
            </RegisterButton>
          </Form>
        ) : (
          <BackButtonContainer>
            <BackButton onClick={handleBackButton}>Voltar</BackButton>
          </BackButtonContainer>
        )}
      </Container>
    </Content>
  );
}
